import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';

@Component({
    selector: 'fi-task-completed-container',
    template: `
        <div class="fi-container fi-container-horizontal-portrait-min ExtraLightBackgroundColor fi-task-list-container">
            <div class="fi-content">
                <fi-task-list-header
                    [tasksViewMode]="FiTasksViewMode.completed"
                    [selectedIndex]="selectedTabNumber"
                    (onSelectedIndexChange)="selectedIndexChange($event)"
                ></fi-task-list-header>
            </div>
        </div>
    `,
    styleUrls: ['./task-completed-container.component.scss', '../task-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TaskCompletedContainerComponent {
    @Input() tasks: ITask[];
    @Input() selectedTabNumber: number;

    constructor(private stateService: FiStateService) {}

    selectedIndexChange(index: number) {
        this.stateService.go(FiStateNames.Task.Completed, { tabNumber: index });
    }

    protected readonly FiTasksViewMode = FiTasksViewMode;
}
